/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import { getWorkerList, getAllUserList } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    check: {
      type: Boolean,
      default: false
    },
    showService: {
      type: Boolean,
      default: false
    },
    // 显示协同人 根据传入的list
    showCollabPeople: {
      type: Boolean,
      default: false
    },
    colist: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    size: {
      type: String,
      default: 'mini'
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      list: [],
      checkList: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
      if (val) {
        this.resetList();
      }
    },
    currValue: function currValue(val) {
      var _this = this;
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
      this.$emit('input', val);
    }
  },
  methods: {
    loadList: function loadList(op) {
      var _this2 = this;
      // getWorkerList({
      //   pageIndex: this.pageIndex++,
      //   pageSize: this.pageSize,
      //   keyword: this.keyword
      // }).then(res => {
      //   this.$refs['workerList'].donePullup()
      //   this.$refs['workerList'].donePulldown()
      //   if (res.success) {
      //     this.list = this.list.concat(res.data)
      //     if (res.data.length < this.pageSize) {
      //       this.$refs['workerList'].disablePullup()
      //     }
      //   } else {
      //     // 暂缺
      //   }
      // })

      if (this.showCollabPeople) {
        this.list = this.colist;
        return;
      }
      var data = {
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        keyword: this.keyword
      };
      this.loadwhichList(data).then(function (res) {
        if (op === 'search') {
          _this2.list = [];
        }
        _this2.$refs['workerList'].donePullup();
        _this2.$refs['workerList'].donePulldown();
        if (res.success) {
          _this2.list = _this2.list.concat(res.data);
          if (res.data.length < _this2.pageSize) {
            _this2.$refs['workerList'].disablePullup();
          }
        } else {
          // 暂缺
        }
      });
    },
    loadwhichList: function loadwhichList(data) {
      if (this.showService) {
        return getWorkerList(data); // 加载服务人员
      } else {
        return getAllUserList(data); // 加载全部用户
      }
    },
    resetList: function resetList() {
      this.list = [];
      this.pageIndex = 0;
      this.$refs['workerList'].enablePullup();
      this.loadList('search');
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    // 多选确认
    onCheckOk: function onCheckOk(ids) {
      this.currValue = false;
      var names = this.list.filter(function (item) {
        return ids.indexOf(item.id) !== -1;
      }).map(function (item) {
        return item.name;
      });
      this.$emit('on-ok', ids, names);
    },
    // 单选
    onRadioOk: function onRadioOk(data) {
      if (!this.check) {
        this.currValue = false;
        this.$emit('on-ok', data);
      }
    }
  },
  created: function created() {
    // this.loadList()
  }
};